export const USER_PERMISSIONS = {
  corporateUser: 3,
};

// From the start of this date (YYYY-MM-DD) in READONLY_TIMEZONE, AU residential office users become read-only
export const READONLY_DATE_FOR_AU = "2026-11-01";
export const READONLY_TIMEZONE = "Australia/Sydney";

// TEMP (local testing only): these emails are always treated as AU residential users. Remove before release.
export const READONLY_TEST_EMAILS = [];
